<template lang="pug">
.mediumTags(id="MediumTagShortInfo-container")
  .tag(v-for='mediumTag in mediumTags', :id="'MediumTagShortInfo-tag' + mediumTag.id",:key='mediumTag.id') {{ mediumTag }}
</template>

<script>

export default {
  props: ['mediumId'],
  components: {
  },
  created () {
    this.medium = this.$store.state.Medium.media_list.find(medium => {
      return medium.id === this.mediumId
    })
  },
  watch: {
    mediumId: function (newVal, oldVal) {
      this.medium = this.$store.state.Medium.media_list.find(medium => {
        return medium.id === this.mediumId
      })
    }
  },
  data () {
    return {
      errors: {
      },
      inputVisible: false,
      addTagName: '',
      medium: undefined
    }
  },
  methods: {
  },
  computed: {
    mediumTags () {
      if (!this.$store.state.Medium.media_tags) return []
      const matchingTags = this.$store.state.Medium.media_tags.filter((mt) => {
        if (!mt || !mt.media) return false
        return mt.media.includes(this.mediumId)
      })
      if (matchingTags) {
        return matchingTags.map(mt => mt.name)
      }
      return []
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";

.tag {
  padding: 3px;
  margin: 1px;
  white-space: nowrap;
  color: $--color-text-secondary;
  background-color: rgba($--color-primary, 0.6);
  font-size: $--font-size-small;
  border: 1px solid rgba(black, 0.8);
  border-radius: 5px;
}
.mediumTags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  opacity: 1;
  overflow: hidden;
  max-height: 88px;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediumTagsShortInfo.vue